import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import Parser from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import { getSelectedLanguagePage } from '../../utils/helpers';
import classes from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation('webCommon');

  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { cmsPages } = useSelector((state) => state.commonReducer);
  const pageData = getSelectedLanguagePage(selectedLanguage, cmsPages, 'privacyPolicy');

  return (
    <div className={classes.page}>
      <Header containerClass="customContainer" />
      <div className={classes?.containerWrapper}>
        <Container className="customContainer py-4">
          <Row className={classes.row}>
            <Col md={12}>
              <h4>{t('privacyPolicy.title')}</h4>
            </Col>
            <Col md={12}>
              <div className={classes.decriptionBox}>{Parser(pageData?.data?.htmlDescription)}</div>
            </Col>
          </Row>

          <div className={classes?.buttonContainer}></div>
        </Container>
      </div>
      <Footer showDownload={false} />
    </div>
  );
};

export default PrivacyPolicy;
